import apiUrl from '../../../constants'
import CommonFunctions from '../../../CommonFunctions'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'register',
    components: {
        VueElementLoading,
        Multiselect,

    },
    data: function() {
        return {
            userid: '',
            utype: '',
            useraction: 'add',

            NoticePeriod: '',
            confirmpassword: '',
            props: [],
            localuserid: 0,
            stateList: [],
            cityList: [],
            listUserTypeData: [],
            clientList: [],
            hubServiceCenterList: [],
            EmployeeTypeData: [],
            EmployeeCategoryData: [],
            OutsourcingData: [],
            ParentUserData: [],
            ReportingUserData: [],
            vendorList: [],
            designationList: [],
            departmentList: [],
            iptrackData:'',
            subdepartmentList: [],
            empTypeList: [],
            empCategoryList: [],
            roles:[],
            show:'',
            userDetails:{
              username:'',
              utype:'',
              roleid:'',
              status:true,
              Sex:'',
              MiddleName:'',
              EmployeeID:'',
              NoticePeriod:'',
              StateId:'',
              CityId:'',
              clientid:'',
              //VendorId:'',
              DepartmentID:'',
              SubdepartmentID:[],
              //ParentUserID:'',
              ReportingUserID:'',
              DesignationID:'',
              OutSourcingID:'',
              HubId:null,
              EmpType:'',
              PositionType:'',
              DateOfRelieving:'',
              EmployeeCategory:'',
              TShirtSize:'',
              ShiftTimings:'',
              WeeklyOff:'',
              Comment:'',
              VehicleNo:'',
              IsActiveReportAdmin:'',
            },
            selectedFile:'',
            s3bucketFileList: [],
            DelUserPhotoScanFiles: '',
            DelUserLicenceScanFiles: '',
            DlvUserPoliceVerificationScanFiles: '',
            DlvUserAadhaarCardVerificationScanFiles: '',
            DlvUserPANCardVerificationScanFiles: '',
            clientBusinessAccountIds: [],
            res_ClientBusinessAccountId: '',
            clientBusinessAccountId_arr:[],
            user_clientid: ''
        }
    },
    created: function() {
    },
    async mounted() {
       this.verify_clientid = ""
        if(!global.hubServiceCenterList){
          let data= await this.getHubServiceCenterData();
          this.hubServiceCenterList=data;
        }else{
          this.hubServiceCenterList=global.hubServiceCenterList;
        }
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        let iptrck= await iptrackerdetails.checkUserIPV2(this.iptrackData,'Register Users',this.$route.path);
        //console.log(iptrck);
        if(iptrck){
          this.$router.push('/');
        }
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.pageno = 0;
        this.getUserTypeData();
        if(this.$route.params.id==undefined){
          this.useraction = "add";
          this.userDetails.VerificationCode = 'DUSF'+Math.floor(Math.random() * (Math.pow(10,5)));
          this.show = false;
        }else{
           let getstring = this.$route.params.id
           let urlclientid = this.$route.query.clientuserdata
           let string = getstring.split("/");
          if(getstring!="" && urlclientid!=undefined){
            let decrypted_clientid = CommonFunctions.prototype.decryptText(urlclientid)
            this.verify_clientid=decrypted_clientid;

          }
          var userid = getstring;
          this.getUserData(userid);

        }
    },
    methods: {
        verify_doj(){
          var birthdate = new Date($("#DateOfBirth").val());
          var joinDate = new Date($("#DateOfJoining").val());

          if (joinDate.getFullYear() - birthdate.getFullYear() < 18){
            alert('You Are Not 18 Year');
          }
        },
        multiple(){
          if(this.userDetails.utype==2){
            return true;
          }else{
            return false;
          }
        },
        closeRegistration(){
          this.$router.push('/user');
        },
        getUserData(userid) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                userid: userid
            })

            this.show = true;
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'userDetails',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(async result => {
                  this.userid = result.data.userdetails.userid;
                  this.utype = result.data.userdetails.utype
                  this.useraction = "edit";
                  this.userDetails = result.data.userdetails;
                  this.user_clientid = result.data.userdetails.clientid;
                  if(this.verify_clientid && this.verify_clientid == this.userDetails.clientid){
                    this.userDetails.password = '';
                  }
                  if(this.userDetails.IMEIChangeDate!=undefined && this.userDetails.IMEIChangeDate!="")
                  {
                      let date = this.userDetails.IMEIChangeDate.split("T");
                      this.userDetails.IMEIChangeDate = date[0];
                  }

                  let selHubs = result.data.userdetails.HubId;
                  let hubarr = [];
                  if(selHubs!=null){
                    selHubs.forEach((hub)=>{
                      let hubname = this.getHubName(hub);
                      if(hubname!="")
                      {
                        hubarr.push({"HubID":hub, "HubName":hubname});
                      }
                    });
                  }
                  this.userDetails.HubId = hubarr;

                  if(this.userDetails.utype==3){
                    this.getStateData();
                    this.getCityData();
                    this.getDepartmentData();
                    this.getDesignationData();
                    this.getReportingUserData();
                    this.getEmpCategoryData();
                    this.getEmpTypeData();
                    this.getOutSourceData();
                    this.getSRVehicleData();
                    this.getS3bucketFiles();
                  }else if (this.userDetails.utype==2)
                  {
                    this.getStateData();
                    this.getCityData();
                    this.getDepartmentData();
                    this.getDesignationData();
                    this.getReportingUserData();
                  }else if (this.userDetails.utype==1) {
                    this.getClientData();
                    let businessAccIds_json = await this.getBusinessAccountIds();
                    if(businessAccIds_json!= null && result.data.userdetails && result.data.userdetails.ClientBussinessAccountId!=null){
                      this.res_ClientBusinessAccountId =  this.getClientBusinessAccountId(result.data.userdetails.ClientBussinessAccountId,businessAccIds_json);
                    }
                  }else if (this.userDetails.utype==4) {
                    this.getClientData();
                    //this.getVendorData();
                  }else{

                  }
                  this.show = false;
                }, error => {
                    console.error(error)
                })
        },
        saveUser() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var username = this.userDetails.username.replace(" ", '_');

            let tempArr=[];
            // this.form.projectidchk.map((obj,key) =>{
            //    if(obj && this.form.projectidwiserole[key]!=""){
            //      tempArr.push({"projects":key,
            //      "roles":this.form.projectidwiserole[key]})
            //     }
            //   });

            let tempHubArr=[];
            let clientBusinessAccId = [];
            if(Array.isArray(this.userDetails.HubId)){
              this.userDetails.HubId.forEach(function(data, index) {
                  tempHubArr.push(data.HubID);
              });
            }else if(this.userDetails.HubId!=null){
              tempHubArr.push(this.userDetails.HubId.HubID);
            }

            let empid=null;
            if(this.userDetails.utype==3){
              let selectedHubid = this.userDetails.HubId;
              empid = selectedHubid.HubName+"_"+this.userDetails.EmployeeID;
            }else if(this.userDetails.utype==2){
              empid = "XB"+this.userDetails.EmployeeID;
            }
            if(this.userDetails.utype==1 && this.res_ClientBusinessAccountId && this.res_ClientBusinessAccountId.length > 0)
            {
              clientBusinessAccId = this.res_ClientBusinessAccountId.map(x => parseInt(x.ClientBusinessAccountId));
            }

            this.input = ({
              username: username,
              email: (this.userDetails.email)?this.userDetails.email:"",
              status: (this.userDetails.status)?this.userDetails.status:null,
              password: this.userDetails.password,
              confirmpassword:this.confirmpassword,
              utype: (this.userDetails.utype)?this.userDetails.utype:null,
              roleid: 3, //bydefault system role 'User' assignment
              EmployeeID: empid,
              FirstName: (this.userDetails.FirstName)?this.userDetails.FirstName:null,
              MiddleName: (this.userDetails.MiddleName)?this.userDetails.MiddleName:null,
              LastName: (this.userDetails.LastName)?this.userDetails.LastName:null,
              Sex: (this.userDetails.Sex)?this.userDetails.Sex:null,
              Age: (this.userDetails.Age)?this.userDetails.Age:null,
              DateOfBirth: this.userDetails.DateOfBirth?this.userDetails.DateOfBirth:null,
              DateOfJoining: (this.userDetails.DateOfJoining)?this.userDetails.DateOfJoining:null,
              DateOfRelieving: (this.userDetails.DateOfRelieving)?this.userDetails.DateOfRelieving:null,
              NoticePeriod: (this.userDetails.NoticePeriod)?this.userDetails.NoticePeriod:null,
              PersonalEmailId: (this.userDetails.PersonalEmailId)?this.userDetails.PersonalEmailId:null,
              MobileNumber: (this.userDetails.MobileNumber)?this.userDetails.MobileNumber:null,
              PhoneNumber: (this.userDetails.PhoneNumber)?this.userDetails.PhoneNumber:null,
              Address: (this.userDetails.Address)?this.userDetails.Address:null,
              StateId: (this.userDetails.StateId)?this.userDetails.StateId:null,
              CityId: (this.userDetails.CityId)?this.userDetails.CityId:null,
              Country: (this.userDetails.Country)?this.userDetails.Country:null,
              Pincode: (this.userDetails.Pincode)?this.userDetails.Pincode:null,
              clientid: (this.userDetails.clientid)?this.userDetails.clientid:null,
              //VendorId: (this.userDetails.VendorId)?this.userDetails.VendorId:null,
              DepartmentID: (this.userDetails.DepartmentID)?this.userDetails.DepartmentID:null,
              ReferredBy: (this.userDetails.ReferredBy)?this.userDetails.ReferredBy:null,
              //ParentUserID: (this.userDetails.ParentUserID)?this.userDetails.ParentUserID:null,
              ReportingUserID: (this.userDetails.ReportingUserID)?this.userDetails.ReportingUserID:null,
              DesignationID: (this.userDetails.DesignationID)?this.userDetails.DesignationID:null,
              SubdepartmentID: (this.userDetails.SubdepartmentID.length>0)?this.userDetails.SubdepartmentID:null,
              ExtensionNo: (this.userDetails.ExtensionNo)?this.userDetails.ExtensionNo:null,
              OutSourcingID: (this.userDetails.OutSourcingID)?this.userDetails.OutSourcingID:null,
              HubId: (tempHubArr.length>0)?tempHubArr:null,
              IsActiveReportAdmin: (this.userDetails.IsActiveReportAdmin)?this.userDetails.IsActiveReportAdmin:null,
              EmpType: (this.userDetails.EmpType)?this.userDetails.EmpType:null,
              EmployeeCategory: (this.userDetails.EmployeeCategory)?this.userDetails.EmployeeCategory:null,
              WeeklyOff: (this.userDetails.WeeklyOff)?this.userDetails.WeeklyOff:null,
              IsSR: (this.userDetails.IsSR)?this.userDetails.IsSR:null,
              IsAgent: (this.userDetails.IsAgent)?this.userDetails.IsAgent:null,
              IsOnRole: (this.userDetails.IsOnRole)?this.userDetails.IsOnRole:null,
              PositionType: (this.userDetails.PositionType)?this.userDetails.PositionType:null,
              ReplaceSRId: (this.userDetails.ReplaceSRId)?this.userDetails.ReplaceSRId:null,
              Comment: (this.userDetails.Comment)?this.userDetails.Comment:null,
              //VehicleNo: (this.userDetails.VehicleNo)?this.userDetails.VehicleNo:null,
              OptionalMobileNumber: (this.userDetails.OptionalMobileNumber)?this.userDetails.OptionalMobileNumber:null,
              IMEINumber: (this.userDetails.IMEINumber)?this.userDetails.IMEINumber:null,
              IsIMEIChanged: (this.userDetails.IsIMEIChanged)?this.userDetails.IsIMEIChanged:null,
              IMEIChangeDate: (this.userDetails.IMEIChangeDate)?this.userDetails.IMEIChangeDate:null,
              IsMobAttendLogin: (this.userDetails.IsMobAttendLogin)?this.userDetails.IsMobAttendLogin:null,
              IsMobNumberVerifiedBySR: (this.userDetails.IsMobNumberVerifiedBySR)?this.userDetails.IsMobNumberVerifiedBySR:null,
              IsVerified: (this.userDetails.IsVerified)?this.userDetails.IsVerified:null,
              VerificationCode: (this.userDetails.utype==3)?this.userDetails.VerificationCode:null,
              AadhaarCardNo: (this.userDetails.AadhaarCardNo)?this.userDetails.AadhaarCardNo:null,
              PANNo: (this.userDetails.PANNo)?this.userDetails.PANNo:null,
              LicenceNo: (this.userDetails.LicenceNo)?this.userDetails.LicenceNo:null,
              IsAdminToSaveLocation: (this.userDetails.IsAdminToSaveLocation)?this.userDetails.IsAdminToSaveLocation:null,
              paymentModeUpdatedBy: (this.userDetails.paymentModeUpdatedBy)?this.userDetails.paymentModeUpdatedBy:null,
              TShirtSize: (this.userDetails.TShirtSize)?this.userDetails.TShirtSize:null,
              ShiftTimings: (this.userDetails.ShiftTimings)?this.userDetails.ShiftTimings:null,
              //projectroleid: tempArr,
              createdby: this.localusermailid,
              modifiedby: this.localusermailid,
              clientBussinessAccountId:(clientBusinessAccId)?clientBusinessAccId: null
            });
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'SubmitUserData',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0) {

                      if(this.userDetails.VehicleNo!=undefined && this.userDetails.utype==3)
                      {
                        let selectedHubid = this.userDetails.HubId.HubID;
                        if(selectedHubid===undefined)
                        {
                          selectedHubid = this.userDetails.HubId[0].HubID;
                        }

                        this.input = {
                          "srid":response.userid,
                          "hubid":parseInt(selectedHubid),
                          "vehicleno":this.userDetails.VehicleNo,
                          "isprimary":1,
                          "createdby":this.localusermailid
                        }

                        axios({
                            method: 'POST',
                            url: apiUrl.api_url + 'external/updateVehicle',
                            data: this.input,
                            headers: {
                              'Authorization': 'Bearer ' + myStr
                            }
                          })
                          .then(result => {
                             //this.$alertify.success(result.message);
                          }, error => {
                            console.error(error)
                          })
                      }
                      this.$alertify.success(response.data.msg);
                      this.$router.push('/user');
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }

                    iptrackerdetails.checkUserIP(this.iptrackData,'User Registration Application',this.$route.path,this.input,response.data);

                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },

        editUser() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var username = this.userDetails.username.replace(" ", '_');
            let tempArr=[];
            // this.form.projectidchk.map((obj,key) =>{
            //    if(obj && this.form.projectidwiserole[key]!=""){
            //      tempArr.push({"projects":key,
            //      "roles":this.form.projectidwiserole[key]})
            //     }
            //   });

            let tempHubArr=[];
            if(Array.isArray(this.userDetails.HubId)){
              this.userDetails.HubId.forEach(function(data, index) {
                  tempHubArr.push(data.HubID);
              });
            }else if(this.userDetails.HubId!=null){
              tempHubArr.push(this.userDetails.HubId.HubID);
            }

            this.input = ({
                userid: this.userid,
                username: username,
                email: (this.userDetails.email)?this.userDetails.email:"",
                status: (this.userDetails.status)?this.userDetails.status:null,
                utype: (this.userDetails.utype)?this.userDetails.utype:null,
                roleid: 3, //bydefault system role 'user' assignment
                EmployeeID: (this.userDetails.EmployeeID)?this.userDetails.EmployeeID:null,
                FirstName: (this.userDetails.FirstName)?this.userDetails.FirstName:null,
                MiddleName: (this.userDetails.MiddleName)?this.userDetails.MiddleName:null,
                LastName: (this.userDetails.LastName)?this.userDetails.LastName:null,
                Sex: (this.userDetails.Sex)?this.userDetails.Sex:null,
                Age: (this.userDetails.Age)?this.userDetails.Age:null,
                DateOfBirth: (this.userDetails.DateOfBirth)?this.userDetails.DateOfBirth:null,
                DateOfJoining: (this.userDetails.DateOfJoining)?this.userDetails.DateOfJoining:null,
                DateOfRelieving: (this.userDetails.DateOfRelieving)?this.userDetails.DateOfRelieving:null,
                NoticePeriod: (this.userDetails.NoticePeriod)?this.userDetails.NoticePeriod:null,
                PersonalEmailId: (this.userDetails.PersonalEmailId)?this.userDetails.PersonalEmailId:null,
                MobileNumber: (this.userDetails.MobileNumber)?this.userDetails.MobileNumber:null,
                PhoneNumber: (this.userDetails.PhoneNumber)?this.userDetails.PhoneNumber:null,
                Address: (this.userDetails.Address)?this.userDetails.Address:null,
                StateId: (this.userDetails.StateId)?this.userDetails.StateId:null,
                CityId: (this.userDetails.CityId)?this.userDetails.CityId:null,
                Country: (this.userDetails.Country)?this.userDetails.Country:null,
                Pincode: (this.userDetails.Pincode)?this.userDetails.Pincode:null,
                clientid: (this.userDetails.clientid)?this.userDetails.clientid:null,
                //VendorId: (this.userDetails.VendorId)?this.userDetails.VendorId:null,
                DepartmentID: (this.userDetails.DepartmentID)?this.userDetails.DepartmentID:null,
                SubdepartmentID: (this.userDetails.SubdepartmentID)?this.userDetails.SubdepartmentID:null,
                ReferredBy: (this.userDetails.ReferredBy)?this.userDetails.ReferredBy:null,
                //ParentUserID: (this.userDetails.ParentUserID)?this.userDetails.ParentUserID:null,
                ReportingUserID: (this.userDetails.ReportingUserID)?this.userDetails.ReportingUserID:null,
                DesignationID: (this.userDetails.DesignationID)?this.userDetails.DesignationID:null,
                ExtensionNo: (this.userDetails.ExtensionNo)?this.userDetails.ExtensionNo:null,
                OutSourcingID: (this.userDetails.OutSourcingID)?this.userDetails.OutSourcingID:null,
                HubId: tempHubArr,
                IsActiveReportAdmin: this.userDetails.IsActiveReportAdmin,
                EmpType: (this.userDetails.EmpType)?this.userDetails.EmpType:null,
                EmployeeCategory: (this.userDetails.EmployeeCategory)?this.userDetails.EmployeeCategory:null,
                WeeklyOff: (this.userDetails.WeeklyOff)?this.userDetails.WeeklyOff:null,
                IsSR: this.userDetails.IsSR,
                IsAgent: this.userDetails.IsAgent,
                IsOnRole: this.userDetails.IsOnRole,
                PositionType: (this.userDetails.PositionType)?this.userDetails.PositionType:null,
                ReplaceSRId: (this.userDetails.ReplaceSRId)?this.userDetails.ReplaceSRId:null,
                Comment: (this.userDetails.Comment)?this.userDetails.Comment:null,
                //VehicleNo: (this.userDetails.VehicleNo)?this.userDetails.VehicleNo:null,
                OptionalMobileNumber: (this.userDetails.OptionalMobileNumber)?this.userDetails.OptionalMobileNumber:null,
                IMEINumber: (this.userDetails.IMEINumber)?this.userDetails.IMEINumber:null,
                IsIMEIChanged: this.userDetails.IsIMEIChanged,
                IMEIChangeDate: (this.userDetails.IMEIChangeDate)?this.userDetails.IMEIChangeDate:null,
                IsMobAttendLogin: this.userDetails.IsMobAttendLogin,
                IsMobNumberVerifiedBySR: this.userDetails.IsMobNumberVerifiedBySR,
                IsVerified: this.userDetails.IsVerified,
                VerificationCode: (this.userDetails.utype==3)?this.userDetails.VerificationCode:null,
                AadhaarCardNo: (this.userDetails.AadhaarCardNo)?this.userDetails.AadhaarCardNo:null,
                PANNo: (this.userDetails.PANNo)?this.userDetails.PANNo:null,
                LicenceNo: (this.userDetails.LicenceNo)?this.userDetails.LicenceNo:null,
                IsAdminToSaveLocation: this.userDetails.IsAdminToSaveLocation,
                paymentModeUpdatedBy: (this.userDetails.paymentModeUpdatedBy)?this.userDetails.paymentModeUpdatedBy:null,
                TShirtSize: (this.userDetails.TShirtSize)?this.userDetails.TShirtSize:null,
                ShiftTimings: (this.userDetails.ShiftTimings)?this.userDetails.ShiftTimings:null,
                modifiedby: this.localusermailid
            })
            let urlclientid = this.$route.query.clientuserdata
             if(urlclientid && urlclientid!=""){
             this.input.password = (this.userDetails.password)?this.userDetails.password:null,
             this.input.confirmpassword =(this.confirmpassword)?this.confirmpassword:null
             }
             if(this.res_ClientBusinessAccountId && this.res_ClientBusinessAccountId.length >0 )
              {
                this.input.clientBussinessAccountId=this.res_ClientBusinessAccountId.map(x => parseInt(x.ClientBusinessAccountId))
              }
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateUser',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0)
                    {
                      if(this.userDetails.VehicleNo!=undefined && this.userDetails.utype==3)
                      {
                        let selectedHubid = this.userDetails.HubId.HubID;
                        if(selectedHubid===undefined)
                        {
                          selectedHubid = this.userDetails.HubId[0].HubID;
                        }

                        this.input = {
                          "srid":this.userid,
                          "hubid":parseInt(selectedHubid),
                          "vehicleno":this.userDetails.VehicleNo,
                          "isprimary":1,
                          "createdby":this.localusermailid
                        }
                        axios({
                            method: 'POST',
                            url: apiUrl.api_url + 'external/updateVehicle',
                            data: this.input,
                            headers: {
                              'Authorization': 'Bearer ' + myStr
                            }
                          })
                          .then(result => {
                            //console.log("res",result.data.transport.message);
                            //this.$alertify.error("VehicleNo " + result.data.transport.message);
                          }, error => {
                            console.error(error)
                          })
                      }
                      this.$alertify.success(response.data.msg);
                      this.$router.push('/user');
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }

                    iptrackerdetails.checkUserIP(this.iptrackData,'Update User Application',this.$route.path,this.input,response.data);

                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },

        //to get State list
        getStateData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/getstatelist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.stateList = result.data.states.data;
            }, error => {
              console.error(error)
            })
        },

        //to get City list
        getCityData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.StateId==""){
            return false;
          }

          var stateid = this.userDetails.StateId;
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/getcitylist?stateid='+stateid,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.cityList = result.data.cities.data;
            }, error => {
              console.error(error)
            })
        },

        //get Hub name
        getHubName(selectedHubid){
          let hubsData = this.hubServiceCenterList;
          let hubname = "";
          hubsData.map(function (hub){
             if(hub.HubID==selectedHubid){
              hubname = hub.HubName;
             }
          });
          return hubname;
        },

        //to get User Type list
        getUserTypeData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getusertypelist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.listUserTypeData = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },

        callAPI(){
          if(this.userDetails.utype=="" || this.userDetails.utype==undefined){
            return false;
          }else if (this.userDetails.utype==1 || this.userDetails.utype==4){
            this.getClientData();
          }else if (this.userDetails.utype==2){
            this.getStateData();
            this.getDepartmentData();
            //this.getSubdepartmentData();
            this.getDesignationData();
          }else if(this.userDetails.utype==3){
            this.getStateData();
            this.getDepartmentData();
            //this.getSubdepartmentData();
            this.getDesignationData();
            this.getOutSourceData();
            this.getEmpCategoryData();
          }
        },

        //to get Client list
        getClientData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/getclientlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.clientList = result.data.clients.data;
            }, error => {
              console.error(error)
            })
        },

        //to get vendor list
        getVendorData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.clientid=="" || this.userDetails.clientid==undefined){
            return false;
          }

          var clientid = this.userDetails.clientid;

          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/getClientVendorslist?clientid='+clientid,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.vendorList = result.data.vendors.data;
            }, error => {
              console.error(error)
            })
        },

        //to get Hub Service Center list
        getHubServiceCenterData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          return axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/gethubservicecenterlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              global.hubServiceCenterList = result.data.hubs.data;
              return result.data.hubs.data;
            }, error => {
              console.error(error)
            })
        },

        //to get Department list
        getDepartmentData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getdepartmentlist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.departmentList = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },
        //to get Subdepartment list
        getSubdepartmentData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.input = ({
            DepartmentID : this.userDetails.DepartmentID
          });
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getsubdepartmentlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {

              if(result.data.data.count!= undefined && result.data.data.count > 0)
              {
                this.subdepartmentList = result.data.data.rows;
              }else{
                this.subdepartmentList = [];
                this.userDetails.SubdepartmentID = '';
              }
            }, error => {
              console.error(error)
            })
        },

        //to get Department list
        getOutSourceData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          axios({
              method: 'GET',
              'url': apiUrl.api_url + 'external/getOutSourcelist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              if(result.data.outsource.data.length>0){
                result.data.outsource.data.forEach(function (outsourceData) {
                  data.push({
                    id:outsourceData.OutSourcingMasterID,
                    label:outsourceData.OutSourcingName
                  });
                });
              }
              this.OutsourcingData = data;
            }, error => {
              console.error(error)
            })
        },

        //to get Designation list
        getDesignationData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getdesignationlist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.designationList = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },

        //to get Employee Type list
        getEmpTypeData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.EmployeeCategory=="" || this.userDetails.EmployeeCategory==undefined){
            return false;
          }

          this.input = ({
            EmpCategoryId : this.userDetails.EmployeeCategory
          });

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getemptypelist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.empTypeList = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },

        //to get Employee Category list
        getEmpCategoryData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getempcategorylist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.empCategoryList = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },

        //to get SR Vehicle Data
        getSRVehicleData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.utype!=3){
            return false;
          }

          let selectedHubid = this.userDetails.HubId;
          this.input = ({
            "srid" : this.userid,
            "hubid" : parseInt(selectedHubid[0].HubID),
            "isprimary":1
          });

          //console.log(this.input);

          axios({
              method: 'POST',
              url: apiUrl.api_url + 'external/getVehicle',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              //console.log("vehicledata",result);
              this.userDetails.VehicleNo = result.data.transport.data[0].VehicleNumber;
            }, error => {
              console.error(error)
            })
        },

        //to get Employee Category list
        getReportingUserData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.DesignationID==""){
            return false;
          }

          if(this.userDetails.DesignationID==null){
            return false;
          }

          this.input = ({
            DesignationID : this.userDetails.DesignationID
          });

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getreportinguserlist',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.ReportingUserData = result.data.data;
            }, error => {
              console.error(error)
            })
        },

        getRandomString(charsLength){
          var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
          var string = '';
        	for(var i=0; i<l; i++)
        		string += chars.charAt(Math.floor(Math.random() * charsLength));

        	return string;
        },

        onSubmit: function (event) {
          if (this.userid != undefined && this.userid != "") {
            if (this.utype === 2 || this.utype === 3) {
              this.editUser();
            }
            else {
              this.$validator.validateAll().then((result) => {
                if (result) {
                  this.editUser();
                }
              }).catch(() => {
                console.log('errors exist', this.errors)
              });
            }

          } else {

            this.$validator.validateAll().then((result) => {
              if (result) {
                this.saveUser();
              }
            }).catch(() => {
              console.log('errors exist', this.errors)
            });
          }
        },

        //function is used for upload files on AWS s3bucket
        onUpload(event){

          this.selectedFile = event.target.files[0];

          if ( /\.(jpe?g|png|gif|bmp)$/i.test(this.selectedFile.name) ){
            var name = event.srcElement.name + "." +this.selectedFile.name.split(".").pop();

            if(event.srcElement.name == 'Xb_DeliveryUser_PhotoFileUpload') var s3bucketKey = 'MIS/DelUserPhotoScanFiles';
            else if(event.srcElement.name == 'Xb_DeliveryUser_LicenceFileUpload') var s3bucketKey = 'MIS/DelUserLicenceScanFiles';
            else if(event.srcElement.name == 'Xb_DeliveryUser_PoliceVerificationFileUpload') var s3bucketKey = 'MIS/DlvUserPoliceVerificationScanFiles';
            else if(event.srcElement.name == 'Xb_DeliveryUser_AadhaarCardVerificationFileUpload') var s3bucketKey = 'MIS/DlvUserAadhaarCardVerificationScanFiles';
            else var s3bucketKey = 'MIS/DlvUserPANCardVerificationScanFiles';

            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            var VerificationCode = document.querySelector("input[name=VerificationCode]").value;

            const fd = new FormData();
            fd.append('file', this.selectedFile, name);
            fd.append('VerificationCode', VerificationCode);
            fd.append('s3bucketKey', s3bucketKey);

            axios.post(apiUrl.api_url + 'uploadFile', fd,
            {
          	  headers: {
          		  'Authorization': 'Bearer ' + myStr
          	  }
            })
            .then(res => {
          	   console.log(res);
            }, error => {
          	  console.error(error)
            });
          }else{
            this.$alertify.error(event.srcElement.placeholder + " Failed! Please Upload Only Valid Format: .png, .jpg, .jpeg, .gif, .bmp");
          }
        },

        //function is used to get all file urls from AWS s3bucket
        getS3bucketFiles(){

          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          if(this.userDetails.VerificationCode==null || this.userDetails.utype!=3){
            return false;
          }

          this.input = ({
            VerificationCode : this.userDetails.VerificationCode
          });

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getfilelist',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then(result => {
            this.s3bucketFileList = JSON.parse(result.data.data);

            this.s3bucketFileList.forEach((row,i)=>{

              //r.data.Contents
              if(row.length>0){
                if((row.filter(p => p.folder == "DelUserPhotoScanFiles")).length>0 == true){
                  this.DelUserPhotoScanFiles = row.filter(p => p.folder == "DelUserPhotoScanFiles");
                }
                if((row.filter(p => p.folder == "DelUserLicenceScanFiles")).length>0 == true){
                  this.DelUserLicenceScanFiles = row.filter(p => p.folder == "DelUserLicenceScanFiles");
                }
                if((row.filter(p => p.folder == "DlvUserPoliceVerificationScanFiles")).length>0 == true){
                  this.DlvUserPoliceVerificationScanFiles = row.filter(p => p.folder == "DlvUserPoliceVerificationScanFiles");
                }
                if((row.filter(p => p.folder == "DlvUserAadhaarCardVerificationScanFiles")).length>0 == true){
                  this.DlvUserAadhaarCardVerificationScanFiles = row.filter(p => p.folder == "DlvUserAadhaarCardVerificationScanFiles");
                }
                if((row.filter(p => p.folder == "DlvUserPANCardVerificationScanFiles")).length>0 == true){
                  this.DlvUserPANCardVerificationScanFiles = row.filter(p => p.folder == "DlvUserPANCardVerificationScanFiles");
                }
              }
            });
            //console.log('re=====', resArr);
          }, error => {
            console.error(error)
          })
        },

        //to get client business account ids list
        getBusinessAccountIds() {
          if (!this.userDetails.clientid || this.userDetails.clientid==null) return;
          return new Promise((resolve, reject)=>{
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if(this.user_clientid && this.user_clientid !=this.userDetails.clientid){
              this.res_ClientBusinessAccountId = [];
              this.clientBusinessAccountIds = [];
            }
            this.input = ({
              clientid : this.userDetails.clientid
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'external/getClientBusinessAccountIds',
                data: this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
              .then(resClientBusinessId => {
                if(resClientBusinessId && resClientBusinessId.data.data)
                {
                  this.clientBusinessAccountIds = resClientBusinessId.data.data;
                  resolve(this.clientBusinessAccountIds)
                }else{
                  resolve(null)
                }
              }, error => {
                console.error(error)
                resolve(null);
              })
          })
        },
        clientBusinessAccountIdLabel ({ AccountName,BusinessFlow, BusinessUnit, ClientBusinessAccountId}) {
          return `${AccountName} ${BusinessFlow} ${BusinessUnit} - (${ClientBusinessAccountId})`
        },
        //get client buscciness account id
        getClientBusinessAccountId(selectedClientBusinessAccountId, businessAccList){
          let clientBusinessAccountid_list = businessAccList;
          let result_json = [];
          selectedClientBusinessAccountId.map(function (listItem){
             clientBusinessAccountid_list.filter(function(item)
            {
              if(item.ClientBusinessAccountId == listItem){
                result_json.push(item);
              }
            });
          });
          return result_json;
        },

    }
}

Validator.extend('verify_password', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and atleast 8 or more characters",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});

Validator.extend('verify_email', {
  getMessage: field => "Only the e-mail address with @xpressbees.com",
  validate: value => {
      var idx = value.indexOf('@xpressbees.com');
      if (idx > -1) {
        return true;
      }else {
        return false;
      }
  }
});

Validator.extend('verify_phone', {
  getMessage: field => "Valid characters: Numbers and space.",
  validate: value => {
    var regex = /^[0-9\s]*$/;
    return regex.test(value);
  }
});

Validator.extend('verify_ischecked', {
  getMessage: field => "Atleast one project selection is required.",
  validate: value => {
    var checkedCount = $('input[name=projectid]:checkbox:checked').length;
    if(checkedCount>0){
      return true;
    }else{
      return false;
    }
  }
});

Validator.extend('verify_doj', {
  getMessage: field => "According to joining date, min age should 18 years.",
  validate: value => {
    var birthdate = new Date($("#DateOfBirth").val());
    var joinDate = new Date($("#DateOfJoining").val());
    var age = joinDate.getYear() - birthdate.getYear();
    var m = joinDate.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && joinDate.getDate() < birthdate.getDate())) {
      age--;
    }
    if (age < 18){
      return false;
    }else{
      return true;
    }
  }
});

Validator.extend('verify_dor', {
  getMessage: field => "Relieving date should be greater than Joining date.",
  validate: value => {
    var relievingdate = new Date($("#DateOfRelieving").val());
    var joinDate = new Date($("#DateOfJoining").val());
     if (joinDate >= relievingdate) {
      return false;
    }else{
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/register/register.component.js